import React from 'react';
import styles from 'Custom/Carousel/CarouselControls.module.scss';

import ArrowLeft from '@/public/icons/arrow-left.svg';
import ArrowRight from '@/public/icons/arrow-right.svg';

const CarouselControls = ({
  onPrev = () => {},
  onNext = () => {},
  className = '',
  ...props
}) => {
  return (
    <div className={`${styles.carouselControls} ${className}`} {...props}>
      <h1>GET TO KNOW NEXPLANON</h1>
      <h2>With our 5 fast facts</h2>
      <div className={styles.controlsContent}>
        <p>NEXPLANON is the birth control implant that goes in your arm.</p>
      </div>
      <div className={styles.controlButtons}>
        <button
          data-design-type="clickAction"
          data-design-category="content_tabs_vd"
          data-design-action="Arrow-Click"
          data-design-label="Left"
          aria-label="Move the card carousel to the left"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          onClick={onPrev}
        >
          <ArrowLeft />
        </button>
        <button
          data-design-type="clickAction"
          data-design-category="content_tabs_vd"
          data-design-action="Arrow-Click"
          data-design-label="Right"
          aria-label="Move the card carousel to the right"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          onClick={onNext}
        >
          <ArrowRight />
        </button>
      </div>
    </div>
  );
};

export default CarouselControls;
